const displayFormatterMixins = {
  data () {
    return {
      monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    }
  },
  methods: {
    toStringDate: function (ms) {
      if (ms) { return new Date(ms).toLocaleString('en-GB') }
    },
    getYearMonthName (ymText) {
      const [year, month] = ymText.split('-')
      const monthName = this.monthNames[parseInt(month) - 1]
      return `${monthName} ${year} `
    },
    getCurrentYearMonthName () {
      let dt = new Date()
      return dt.toLocaleString('en-GB', { month: 'long' }) + ' ' + dt.getFullYear()
    },
    toStringDateOnly: function (ms) {
      return new Date(ms).toLocaleDateString('en-GB')
    },
    toPriceFormat: function (p) {
      return new Intl.NumberFormat().format(p)
    },
    toPhoneFormat: function (str) {
      // (021) 2421-4212
      if (str && str.length > 7) {
        return [('(' + str.substring(0, 3) + ')'), [str.substring(3, 7), str.substring(7, 15)].join('-')].join(' ')
      }
      return str
    },
    toTimeFormat: function (str) {
      if (str && str.length === 4) {
        return str.slice(0, 2) + ':' + str.slice(2, 4)
      }
      return str
    },
    getDifferenceInDays: function (date1, date2) {
      const diffInMs = Math.abs(date2 - date1)
      return Math.floor(diffInMs / (1000 * 60 * 60 * 24))
    },
    getDifferenceInHours: function (date1, date2) {
      const diffInMs = Math.abs(date2 - date1)
      return diffInMs / (1000 * 60 * 60)
    },
    getDifferenceInMinutes: function (date1, date2) {
      const diffInMs = Math.abs(date2 - date1)
      return diffInMs / (1000 * 60)
    },
    getDifferenceInSeconds: function (date1, date2) {
      const diffInMs = Math.abs(date2 - date1)
      return diffInMs / 1000
    }
  }
}

export default displayFormatterMixins
